export var global=
{
  url:"https://app.verfrut.cl/api-app/public/index.php/api/"
 // url:'https://app.verfrut.cl/api-app/public/index.php/api/',
}

